export default "__VITE_ASSET__885eeab6__"